export default __webpack_public_path__ + "static/media/successProfileCreate.dd4d9251.svg";